<template>
  <div
    class="grid-item"
    :style="{
      marginRight: isRowEnd ? 0 : grid.rowMargin,
      marginBottom: isLastRow ? '0' : marginBottom ? marginBottom + 'px' : grid.colMargin,
      width: `calc(${calcWidth})`
    }"
    @click="$emit('click')"
  >
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'GridItem',
  props: ['marginBottom'],
  data() {
    return {}
  },
  inject: ['grid'],
  computed: {
    calcWidth() {
      const { cols, rowMargin } = this.grid.$props
      const num = parseFloat(rowMargin, 10)
      const unit = rowMargin.split(String(num))[1]
      return `(100% - ${num * (cols - 1) + unit}) / ${cols || 1}`
    },
    isRowEnd() {
      const { cols } = this.grid
      const children = this.grid.$children
        .filter((i) => i.$options.name === this.$options.name)
        .map((item) => item._uid)
      const me = this._uid
      const index = children.findIndex((item) => item === me)
      if (index + 1 > 0) {
        if ((index + 1) % cols === 0) {
          return true
        }
      }
      return false
    },
    isLastRow() {
      let deadline
      const len = this.grid.childLength
      const children = this.grid.$children
        .filter((i) => i.$options.name === this.$options.name)
        .map((item) => item._uid)
      const index = children.findIndex((id) => id === this._uid)
      const { cols } = this.grid
      const mod = len % cols
      const nature = Math.floor(len / cols)
      if (mod === 0) {
        deadline = (nature - 1) * cols - 1
      } else {
        deadline = nature * cols - 1
      }
      return index > deadline
    }
  },
  created() {
    this.dispatch('grid', 'childAdd')
  },
  beforeDestroy() {
    this.dispatch('grid', 'childRm')
  },
  mounted() {},
  methods: {
    dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root
      var name = parent.$options.componentName

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent

        if (parent) {
          name = parent.$options.componentName
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params))
      }
    }
  }
}
</script>
<style lang="scss">
.grid-item {
  flex-shrink: 0;
}
</style>
